/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  useFormikContext,
  FormikHandlers,
  FormikErrors,
  FormikTouched,
} from 'formik';
import { get } from 'lodash';

export interface FieldInputProps<T> {
  /** Value of the field */
  value: T;
  /** Name of the field */
  name: string;
  type: number;
  /** Multiple select? */
  /* multiple?: boolean; */
  /** Is the field checked? */
  /* checked?: boolean; */
  /** Change event handler */
  onChange: FormikHandlers['handleChange'];
  /** Blur event handler */
  onBlur: FormikHandlers['handleBlur'];
}

export interface FieldMetaProps<T> {
  /** Error message of the field */
  error?: FormikErrors<T>;
  /** Has the field been visited? */
  touched: FormikTouched<T>;
  /** Initial value of the field */
  /* initialValue?: Value; */
  /** Initial touched state of the field */
  /* initialTouched: FormikTouched<T>; */
  /** Initial error message of the field */
  /* initialError?: FormikErrors<T>; */
}

export interface FieldHelperProps<T> {
  setValue(value: any, shouldValidate?: boolean): void;
  setTouched(value: any, shouldValidate?: boolean): void;
  setFieldError(field: string, message: string): void;
}

/**
 * Retrieves utilities(values, errors, setField, etc) from a formik field.
 * @param {number} profileType Type of the profile type chosen.
 * @param {string} fieldName Name of the field you want to retrieve.
 * @requires Requires formik context.
 */
export function useFormikField<T>(fieldName: string) {
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    setFieldError,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<T>();

  const field = {
    name: fieldName,
    type: (values as any)?.settings?.type,
    value: get(values, fieldName),
    onChange: handleChange,
    onBlur: handleBlur,
  };

  const meta = {
    error: get(errors, fieldName),
    touched: get(touched, fieldName),
  };

  const helpers = {
    setValue: (value: any, shouldValidate?: boolean) =>
      setFieldValue(fieldName, value, shouldValidate),
    setTouched: (value: any, shouldValidate?: boolean) =>
      setFieldTouched(fieldName, value, shouldValidate),
    setFieldError,
  };

  return [field, meta, helpers] as [
    FieldInputProps<T>,
    FieldMetaProps<T>,
    FieldHelperProps<T>,
  ];
}
